import React from 'react';
import Icon from '@ant-design/icons';

const icon = () => (
	<svg width="1em" height="1em" viewBox="0 0 24 24" version="1.1">
		<g id="icon/help_outline_black_24dp" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<path
				d="M11,18 L13,18 L13,16 L11,16 L11,18 Z M12,1.99999996 C6.47999998,1.99999996 1.99999996,6.47999998 1.99999996,12 C1.99999996,17.52 6.47999998,22 12,22 C17.52,22 22,17.52 22,12 C22,6.47999998 17.52,1.99999996 12,1.99999996 Z M12,20 C7.58999998,20 3.99999997,16.41 3.99999997,12 C3.99999997,7.58999998 7.58999998,3.99999997 12,3.99999997 C16.41,3.99999997 20,7.58999998 20,12 C20,16.41 16.41,20 12,20 Z M12,5.99999998 C9.78999999,5.99999998 7.99999998,7.78999998 7.99999998,9.99999998 L9.99999998,9.99999998 C9.99999998,8.89999999 10.9,7.99999998 12,7.99999998 C13.1,7.99999998 14,8.89999999 14,9.99999998 C14,12 11,11.75 11,15 L13,15 C13,12.75 16,12.5 16,9.99999998 C16,7.78999998 14.21,5.99999998 12,5.99999998 Z"
				id="Combined-Shape"
				fill="currentColor"
			></path>
		</g>
	</svg>
);

const QuestionCircle = (props) => {
	return <Icon {...props} component={icon} />;
};
export default QuestionCircle;
